import { toast } from "react-hot-toast";
import "react-toastify/dist/ReactToastify.css";

const useNotification = () => {
    const showToast = (message, options = {}) => {
        toast(message, {
            style: {
                padding: "16px",
                color: options.color || "#fff",
                backgroundColor: options.backgroundColor || "#025cd8",
                width: options.width || "auto",
            },
            position: options.position || "top-center",
            theme: options.theme || "colored",
            ...options,
        });
    };

    return {
        showNotice: (message) =>
            showToast(message || "Notice! : You have not notifications", {
                backgroundColor: "#025cd8",
            }),
        showSuccess: (message) =>
            showToast(message || "Success! Operation completed", { backgroundColor: "#29bf74" }),
        showWarning: (message) =>
            showToast(message || "Warning! Read details carefully", { backgroundColor: "#ffc720" }),
        showInfo: (message) =>
            showToast(message || "Information! Check the updates", { backgroundColor: "#00b9ff" }),
        showError: (message) =>
            showToast(message || "Error! Please check your details", {
                backgroundColor: "#ff5b51",
            }),
    };
};

export default useNotification;
